var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[(_vm.prefixCls + "-link"), ( _obj = {}, _obj[(_vm.prefixCls + "-link-active")] = _vm.active, _obj )]},[_c('div',{class:[(_vm.prefixCls + "-link-title"), ( _obj$1 = {}, _obj$1[(_vm.prefixCls + "-link-title-active")] = _vm.active, _obj$1 )],attrs:{"href":_vm.href,"title":_vm.title},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c7fe85d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/privacy/components/anchorLink.vue
// module id = null
// module chunks = 